<template>
<v-card>
  <request-status
    :request="req"
    @ok="$emit('saved');$emit('close')"
    message200="Account successfully reactivated" />
  <v-card-title class='subtitle-1 overline' >
    {{title}}
    <v-spacer/>
    <v-btn small icon @click="$emit('close')" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text >

    <v-text-field
      :type="type"
      :append-icon="typeIcon"
      label="new password"
      @click:append="toggleType"
      v-model="password" />

    <v-checkbox persistent-hint
      v-model="confirm"
      label="Reactivate account"
      hint="Reactivated account will resume billing on your next billing cycle" />
  </v-card-text>
  <v-card-actions >
    <v-spacer/>
    <v-btn
      @click="reactivate" color="primary"
      :disabled="!confirm"
      :loading="req.loading" >Reactivate</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>

export default {
  name: 'ReactivateAccount',
  props: {
    title: { type: String },
    businessId: { required: true },
    practitioner: { required: true }
    // space: { required: true }
  },
  data () {
    return {
      confirm: false,
      type: 'password',
      typeIcon: 'mdi-eye-outline',
      password: null,
      req: {
        resource: 'ag.team',
        extra: 'reactivate_account',
        method: 'post'
      }
    }
  },
  methods: {
    reactivate () {
      this.req.data = {
        business: this.businessId,
        practitioner: this.practitionerId,
        password: this.password
      }
      this.$request('save', this.req)
    },
    toggleType () {
      if (this.type === 'password') {
        this.type = 'text'
        this.typeIcon = 'mdi-eye-off-outline'
      } else {
        this.type = 'password'
        this.typeIcon = 'mdi-eye-outline'
      }
    }
  },
  computed: {
    isActive () {
      return this.getObjectPath(this.practitioner, 'user.is_active', false)
    },
    practitionerId () {
      return this.getObjectPath(this.practitioner, 'user.id')
    }
  },
}
</script>
